/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto. Keeping custom
* JavaScript here makes future Palo Alto theme updates easier.
*/

(function() {
  /*
   * The theme gives hero images an `is-loading` class whose global CSS keeps
   * them almost transparent until the image-loader JavaScript removes it.
   * This deferred script runs as soon as the document has been parsed, so
   * release the first homepage hero immediately instead of allowing its paint
   * (and therefore LCP) to depend on the later slider/image-loader lifecycle.
   */
  const homepageHero = document.body.classList.contains('template-index')
    ? document.querySelector('[data-main] [data-section-type="slider"][data-slider]')
    : null;

  const deferredHeroPictures = homepageHero
    ? Array.from(homepageHero.querySelectorAll('[data-deferred-picture]'))
    : [];
  let deferredHeroPicturesLoaded = false;

  const loadDeferredHeroPictures = function() {
    if (deferredHeroPicturesLoaded || deferredHeroPictures.length === 0) return;
    deferredHeroPicturesLoaded = true;

    deferredHeroPictures.forEach(function(picture) {
      picture.querySelectorAll('source[data-srcset]').forEach(function(source) {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });

      const image = picture.querySelector('img[data-src]');
      if (!image) {
        picture.style.removeProperty('visibility');
        picture.removeAttribute('aria-hidden');
        picture.removeAttribute('data-deferred-picture');
        return;
      }

      const revealImage = function() {
        if (image.dataset.alt !== undefined) {
          image.alt = image.dataset.alt;
          image.removeAttribute('data-alt');
        }
        image.removeAttribute('aria-hidden');
        picture.removeAttribute('aria-hidden');
        picture.style.removeProperty('visibility');
        image.classList.remove('is-loading');
        picture.classList.remove('is-loading');
      };

      image.addEventListener('load', revealImage, { once: true });
      image.addEventListener('error', revealImage, { once: true });
      image.loading = 'eager';
      image.fetchPriority = 'low';

      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        image.removeAttribute('data-srcset');
      }

      image.src = image.dataset.src;
      image.removeAttribute('data-src');
      picture.removeAttribute('data-deferred-picture');

      if (image.complete) revealImage();
    });
  };

  /*
   * Do not put hidden slides back into the initial network or paint path after
   * an arbitrary idle timeout. They become real image requests only when the
   * visitor shows intent to use the carousel. This prevents a later full-size
   * slide from replacing the first hero as Lighthouse's LCP candidate.
   */
  if (homepageHero && deferredHeroPictures.length > 0) {
    ['pointerover', 'pointerdown', 'touchstart', 'keydown', 'focusin'].forEach(function(eventName) {
      homepageHero.addEventListener(eventName, loadDeferredHeroPictures, {
        once: true,
        passive: eventName !== 'keydown' && eventName !== 'focusin'
      });
    });
  }

  if (homepageHero) {
    const firstSlide = homepageHero.querySelector('[data-slide].is-selected')
      || homepageHero.querySelector('[data-slide]');
    const criticalPicture = firstSlide
      ? firstSlide.querySelector('.slide__image.lazy-image')
      : null;
    const criticalImage = criticalPicture
      ? criticalPicture.querySelector('img')
      : null;

    if (criticalPicture) {
      criticalPicture.classList.remove('is-loading');
    }

    if (criticalImage) {
      criticalImage.loading = 'eager';
      criticalImage.fetchPriority = 'high';
      criticalImage.classList.remove('is-loading');
      criticalImage.style.opacity = '1';
      criticalImage.style.transition = 'none';

      const markHeroReady = function() {
        homepageHero.classList.add('img-in');
      };

      if (criticalImage.complete) {
        markHeroReady();
      } else {
        criticalImage.addEventListener('load', markHeroReady, { once: true });
      }
    }
  }

  /*
   * Keep the homepage hero on its first slide during the initial render.
   * The theme reads data-autoplay on DOMContentLoaded, so this must run at
   * script evaluation time rather than inside a load/DOMContentLoaded event.
   * Autoplay is enabled only after the visitor interacts with the hero.
   */
  if (homepageHero && homepageHero.dataset.autoplay === 'true') {
    const autoplayDuration = Number.parseInt(homepageHero.dataset.duration, 10) || 3000;
    homepageHero.dataset.autoplay = 'false';
    homepageHero.setAttribute('data-autoplay-deferred', 'true');

    const enableHeroAutoplay = function() {
      const startPlayer = function(attemptsRemaining) {
        const Flickity = window.themeVendor && window.themeVendor.Flickity;
        const instance = Flickity && typeof Flickity.data === 'function'
          ? Flickity.data(homepageHero)
          : null;

        if (instance) {
          homepageHero.dataset.autoplay = 'true';
          homepageHero.removeAttribute('data-autoplay-deferred');
          instance.options.autoPlay = autoplayDuration;
          instance.playPlayer();
          return;
        }

        if (attemptsRemaining > 0) {
          window.setTimeout(function() {
            startPlayer(attemptsRemaining - 1);
          }, 100);
        }
      };

      startPlayer(20);
    };

    homepageHero.addEventListener('pointerdown', enableHeroAutoplay, { once: true });
    homepageHero.addEventListener('keydown', enableHeroAutoplay, { once: true });
  }

  window.addEventListener('load', function() {
    document.querySelectorAll('footer p, footer a').forEach(function(element) {
      if (element.innerText.includes('Shopify')) {
        element.remove();
      }
    });

    const poweredByElement = document.querySelector('.footer-copyright__powered');
    if (poweredByElement && poweredByElement.innerText.trim() === '.') {
      poweredByElement.remove();
    }

    const footerText = document.querySelector('.footer-copyright__content');
    if (footerText) {
      footerText.innerHTML = footerText.innerHTML.replace(/2025,\s?/g, '2025 ');
    }
  });
})();